// React
import { useState } from "react"

// Translations
import { Trans, useTrans } from "@/i18n"

// UI
import { CompanyDetails } from "./_components/CompanyDetails"
import { OrganisationSelector } from "./_components/OrganisationSelector"
import { Disclaimer } from "@/components/Disclaimer"

// Context
import { useCurrentUserIdentityType } from "@/context/user"

// API
import { UsersUserProfileIdentityTypeChoices } from "@/api/graphql"

/**
 * ProfileCompanyDetails
 *
 * @returns
 */
export const ProfileCompanyDetails = () => {
	const t = useTrans("profile")
	const identity_type = useCurrentUserIdentityType()

	// State
	const [selectedOrganisationId, setSelectedOrganisationId] = useState<
		string | undefined
	>(undefined)

	return (
		<>
			<title>
				{t("common:web.title", {
					page: t("profile:company_details.title"),
				})}
			</title>

			{identity_type === UsersUserProfileIdentityTypeChoices.Business ? (
				<>
					<div className="mb-4 flex justify-end">
						<OrganisationSelector
							onChange={setSelectedOrganisationId}
							selectedOrganisationId={selectedOrganisationId}
						/>
					</div>
					<CompanyDetails
						selectedOrganisationId={selectedOrganisationId}
					/>
				</>
			) : (
				<Disclaimer
					className="mb-3"
					title={t("profile:company_details.no-organisation.header")}
					message={
						<Trans
							i18nKey="profile:company_details.no-organisation.copy"
							components={{
								//oxlint-disable-next-line jsx-a11y/anchor-has-content
								a: <a href="mailto:info@zonhub.com" />,
							}}
						/>
					}
				/>
			)}
		</>
	)
}
